import type { ReactNode } from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

// Page heading with an optional slot for right-hand actions. Responsive
// size: h5 on a phone, h4 from sm up.
export function Title({ label, children }: { label: string; children?: ReactNode }) {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ mb: 2, minHeight: 44, alignItems: 'center', justifyContent: 'space-between' }}
    >
      <Typography variant="h5" component="h1" sx={{ typography: { sm: 'h4' } }}>
        {label}
      </Typography>
      {children}
    </Stack>
  )
}
